import moment from 'moment';
import { ActionSheetController, Platform, Slides } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Camera } from '@ionic-native/camera';
import { Component, ViewChild } from '@angular/core';
import { Diagnostic } from '@ionic-native/diagnostic';
import { FileTransfer } from '@ionic-native/file-transfer';
import { Geolocation } from '@ionic-native/geolocation';
import { IonicPage } from 'ionic-angular';
import { LoopBackConfig } from './../../../shared/sdk/lb.config';
import { NavController, AlertController, NavParams, LoadingController, Events, ModalController, ViewController } from 'ionic-angular';
import { Network } from '@ionic-native/network';
import { PermissionCheckProvider } from '../../../providers/permission-check/permission-check';
import { SFAttUploadSF6Api } from './../../../shared/sdk/services/custom/SFAttUploadSF6';
import { SFAttendanceApi } from './../../../shared/sdk/services/custom/SFAttendance';
import { SFAttendanceSF6Api } from './../../../shared/sdk/services/custom/SFAttendanceSF6';
import { SFAttendanceStatusApi } from './../../../shared/sdk/services/custom/SFAttendanceStatus';
import { Storage } from '@ionic/storage';
import { StoragePathProvider } from "../../../providers/storage-path/storage-path";
import { Subscription } from 'rxjs/Subscription';
import { SunfishApi } from '../../../shared/sdk/services/custom/Sunfish';
import { TclmuserApi } from './../../../shared/sdk/services/custom/Tclmuser';
import { TeomemppersonalApi } from './../../../shared/sdk/services/custom/Teomemppersonal';
import { ToastController } from 'ionic-angular';
import { ToastServiceProvider } from '../../../providers/toast-service/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { TtadattendanceApi } from './../../../shared/sdk/services/custom/Ttadattendance';
import { TtamshiftdailyApi } from './../../../shared/sdk/services/custom/Ttamshiftdaily';
import { SettingServiceApi } from '../../../shared/sdk/services/custom/SettingService';
import { AlertServiceProvider } from '../../../providers/alert-service/alert-service';
import { CustomPluginProvider } from '../../../providers/custom-plugin/custom-plugin';
import { AnalyticsProvider } from "../../../providers/analytics/analytics";
import { AppVersion } from '@ionic-native/app-version';
import { PageBuilderSubmenuApiProvider } from './../../../pagebuilder/services/menu/submenu/pagebuilder-submenu-api';
import _ from 'lodash';
import { SFProfileApi } from '../../../shared/sdk/services/custom/SFProfile';
import { SFGOAuthService } from '../../../providers/sfgoauth.service/sfgoauth.service';
import { GDAuthInterface } from '../../../model/gd-auth';
import { AttendanceBloc } from '../../../bloc/hr/attendance/attendance.bloc';
import { PollingBloc } from '../../../bloc/feature/polling/polling.bloc';
import { AttendanceTempBloc } from '../../../bloc/hr/attendance/attendance-temp.bloc';
import { ResponseNewTodayAttendance } from '../../../shared/nestjs/gd-only/dto/attendance.dto';
import { AttendancePreviewData } from '../../../model/attendance/attendance-preview.model';
import { AttendanceFaceBloc } from '../../../bloc/hr/attendance/attendance-face.bloc';
import { GlobalServiceProvider } from '../../../providers/global-service/global-service';
import { RequestGetEmpDto } from '../../../shared/nestjs/gd-only/dto/sf-profile.dto';
import { ProfileBloc } from '../../../bloc/feature/profile/profile.bloc';
import { EventNameAnalytics } from '../../../helpers/event-name-analytics';

declare var window: any;
/**
 *  Note :
 *  THIS PAGE IS ONLY FOR INTEGRATED ATTENDANCE SUNFISH 6
 */

@IonicPage()
@Component({
  selector: 'page-time-attendance',
  templateUrl: 'time-attendance.html'
})
export class TimeAttendance {
  @ViewChild('fileInput') fileInput;
  @ViewChild(Slides) slides: Slides;

  toggleNext: boolean = true;
  togglePrev: boolean = false;

  public SFGoAuth: GDAuthInterface;
  public myDate: any;
  public active_date: any; //datetime ketika page aktif, jika refresh page maka berubah lagi

  public newendtime: any;
  public newshiftcode: any;
  public newshiftname: any;
  public newshiftend: any;
  public newshiftstart: any;
  public newstarttime: any = null;

  public clockIn: any = null;
  public clockOut: any = null;
  public actualClockIn: any = null;
  public actualClockOut: any = null;

  public disabledStart = false;
  public disabledEnd = false;
  public emp_id: any;
  public company_id: any;

  public attend_today: any = [];
  public attend_yesterday: any = [];
  public btnDisabled = true;
  public feedBack: any;

  public flag_yesterday_check = true;
  public flag_can_start = false;
  public flag_change_yesterday = false;
  public flag_inputStatus: any; //penting
  public mindiff: number;
  public attendancelist: any = 'TimeAttendanceListNewPage';

  public attcorrpage: any;
  public leavepage: any;
  public overtimepage: any;
  public shiftpage: any;
  public businesstrip: any;
  public isProfile = false;
  public empId: any;
  public empname: any;
  public empno: any;
  public userEmpid: any;

  public showAE = false;
  public showAC = false;
  public showLeave = false;
  public showShift = false;
  public showOvt = false;
  public showAL = false;
  public showATTV = false;
  public isSF6 = false;
  public showOffline = false;
  public showBarcode = false;
  public showBST = false;
  public showMassLeave = false;
  public userId: any;
  public photoProfile: any;
  public name: any;
  public position: any;
  public sub: any;

  public showHelp = false;
  public subscriptions: Array<Subscription> = [];
  public loopbackPath: string = LoopBackConfig.getPath();
  public isCamera;
  public statusAttendanceWeb: any;
  public startDegree = 0;
  public endDegree = 0;
  public isOnline: any = true;
  public subject: any;
  public today: any;
  public isSpinner: any = false;
  public isRecordTime: boolean = false;
  public progressRecord: any = "Record Time";
  // define setting attendance
  public takePhoto: boolean = true; // 1 = true
  public isDisabled: boolean = false;
  public pages: Array<{ title: string, component: any, icon: any, show: boolean }>;
  public isCordova: boolean = false;
  public SFGoStorage: any;
  public path: any;
  public oldPATHUrl: any;
  public newPATH: boolean = false;
  public newPATHUrl: any;
  public menus: any = [];
  public submenus: any = [];
  public versionApps: String;
  public flag: any = {
    showMenu: false,
  }
  public attendanceData: ResponseNewTodayAttendance;
  public isSkeleton: boolean = false;
  public showABP = false;
  public showBreakBtn: boolean;

  constructor(
    public TclmuserApi: TclmuserApi,
    public alertCtrl: AlertController,
    public events: Events,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public navparams: NavParams,
    public sfattendanceApi: SFAttendanceApi,
    public sfattendancesf6Api: SFAttendanceSF6Api,
    public sfattendancestatusApi: SFAttendanceStatusApi,
    public sfattuploadsf6Api: SFAttUploadSF6Api,
    public storage: Storage,
    public sunfish: SunfishApi,
    public teomemppersonalApi: TeomemppersonalApi,
    public translate: TranslateService,
    public ttadattendanceApi: TtadattendanceApi,
    public ttamshiftdailyApi: TtamshiftdailyApi,
    public actionSheetCtrl: ActionSheetController,
    public toastCtrl: ToastController,
    public platform: Platform,
    public barcodeScanner: BarcodeScanner,
    public camera: Camera,
    public transfer: FileTransfer,
    public diagnostic: Diagnostic,
    public geolocation: Geolocation,
    public toastService: ToastServiceProvider,
    public permissionCheckProvider: PermissionCheckProvider,
    public storagePathProvider: StoragePathProvider,
    public network: Network,
    public settingServiceApi: SettingServiceApi,
    public alertService: AlertServiceProvider,
    public customPlugin: CustomPluginProvider,
    public attendanceBloc: AttendanceBloc,
    public analyticsProvider: AnalyticsProvider,
    public viewCtrl: ViewController,
    private _pageBuilderSubmenuApiProvider: PageBuilderSubmenuApiProvider,
    public appVersion: AppVersion,
    public profileApi: SFProfileApi,
    public sfgoAuthService: SFGOAuthService,
    public pollingBloc: PollingBloc,
    public attendanceTempBloc: AttendanceTempBloc,
    public attendaneFaceBloc: AttendanceFaceBloc,
    public globalServiceProvider: GlobalServiceProvider,
    public profileBloc: ProfileBloc,
  ) {
    this.isCordova = this.platform.is('cordova') ? true : false;
    this.getDateToday();
  }

  async ionViewDidLoad() {
    try {
      this.path = LoopBackConfig.getPath();
      this.SFGoAuth = await this.sfgoAuthService.getAuthorization();
      this.isSF6 = this.SFGoAuth.isSF6 == 1 ? true : false;
      this.company_id = this.SFGoAuth.accId || this.SFGoAuth.companyId;
      this.empname = this.SFGoAuth.fullName;
      this.empno = this.SFGoAuth.empNo;
      this.userEmpid = this.SFGoAuth.empId;
      this.empId = this.navparams.get('empid') != undefined ? this.navparams.get('empid') : this.SFGoAuth.empId;
      this.isProfile = this.navparams.get('empid') != undefined ? false : true;
      this.active_date = moment().format();
      this.attendaneFaceBloc.doGetNeedApproval();

      if (this.navparams.get('empid') != undefined) {
        await this.loadProfile(this.navparams.get('empid'));
      } else {
        this.userId = this.SFGoAuth.userId;
        this.photoProfile = this.SFGoAuth.photo;
        this.name = this.SFGoAuth.fullName;
        this.position = this.SFGoAuth.position;
      }

      await this.funcAuth();
      this.getMenus();
      await this.runEvents();
      await this.getSfGoStorage();
      await this.attendanceBloc.getCompanySetting();
      await this.loadVersionApps();
      this.attendanceBloc.params.setting = await this.attendanceBloc.getAttendanceSetting();
      await this.getBreakButton();
    }
    catch (error) {
      console.log('ionViewDidload Error', error);
    }
  }

  async ionViewDidEnter() {
    try {

      await this.getCurrentTime();
      await this.checkAttendance();

      if (!_.isEmpty(this.navparams.data) && this.navparams.data.menuId) {
        await this.getSubmenus(this.navparams.data.menuId);
        if (this.submenus.length > 0) {
          this.replaceMenuExist();
        }
        this.flag.showMenu = true;
      } else {
        this.flag.showMenu = true;
      }
    } catch (error) {
      console.log('ionViewDidEnter Error', error);
    }
  }

  async getDateToday() {
    const language = await this.storage.get('language');
    const data = this.globalServiceProvider.languageList.filter(params => { return params.value == language });
    moment.locale(data[0].locale);
    this.today = moment().format('ddd, DD MMM YYYY');
  }

  async getSfGoStorage(): Promise<any> {
    // console.log('TCL:Get Storage');
    return new Promise((resolve) => {
      this.storage.ready().then(() => {
        this.storage.get('SFGoStorage').then(async (hasil) => {
          if (hasil != null && hasil != undefined) {
            this.SFGoStorage = JSON.parse(hasil);
            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin) {
              this.oldPATHUrl = this.SFGoStorage.storedPrelogin.GOPATH;
            } else {
              this.oldPATHUrl = this.path;
            }
            let path;
            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin &&
              this.SFGoStorage.storedPrelogin.hasOwnProperty('GOPATHNEW') && this.SFGoStorage.storedPrelogin.GOPATHNEW) {
              // console.log('TCL:New Path Found');
              this.newPATH = true;
              path = this.SFGoStorage.storedPrelogin.GOPATHNEW;
              this.newPATHUrl = path;
            } else {
              // console.log('TCL:New Path Not Found');
              this.newPATH = false;
            }
            // this.newPATHUrl = 'http://localhost:30000' // local nestjs;
            // this.newPATHUrl = 'http://localhost:5000' // local loopback;
            resolve(true);
          }
        });
      });
    });
  }

  async getSubmenus(parentId) {
    return new Promise(async (resolve, reject) => {
      this._pageBuilderSubmenuApiProvider.getSubmenu(parentId).then(response => {
        this.submenus = response;
        resolve(true);
      }, (error) => {
        resolve(error);
      });
    });
  }

  getMenus() {
    this.menus = [
      {
        title: 'Attendance List',
        icon: 'sficon-tasktime',
        action: 'attListPage',
        show: this.showAL,
      },
      {
        title: 'Attendance Correction',
        icon: 'sficon-chart',
        action: 'attCorrectionPage',
        show: this.showAC,
      },
      // {
      //   title: 'Attendance Base Photo',
      //   iconUrl: 'assets/icon_new/attendance/att-base-photo.svg',
      //   action: 'attBaseDashboardPage',
      //   show: this.showABP,
      //   totalAlet: 0
      // },
      {
        title: 'Leave',
        icon: 'sficon-persontime',
        action: 'leavePage',
        show: this.showLeave,
      },
      {
        title: 'Overtime',
        icon: 'sficon-briefcasetime',
        action: 'overtimePage',
        show: this.showOvt,
      },
      {
        title: this.isSF6 ? 'On Duty' : 'Business Trip',
        icon: 'sficon-businesstrip',
        action: 'businessPage',
        show: this.showBST,
      },
      {
        title: 'Shift Schedule',
        icon: 'sficon-shiftschedule',
        action: 'shiftPage',
        show: this.showShift,
      },
      {
        title: 'Mass Leave',
        icon: 'sficon-rounddash',
        action: 'massLeavePage',
        show: this.showMassLeave,
      },
    ];

    this.flag.showMenu = true
  }

  isImageFile(data: any): boolean {
    // TODO parsing data check apakah dia class atau file
    if (data.includes("http") || data.includes('assets/')) {
      return true;
    } else {
      return false;
    }
  }

  generateMenuIconUrl(rawPath: any): string {
    if (rawPath) {
      let result = rawPath.replace(new RegExp('{FILE_TOKEN}', 'g'), this.SFGoAuth.id);
      if (this.newPATHUrl != undefined && this.newPATHUrl != null) {
        result = result.replace(new RegExp('{PICTURE_PATH}', 'g'), this.newPATHUrl);
      } else {
        result = result.replace(new RegExp('{PICTURE_PATH}', 'g'), this.oldPATHUrl);
      }
      return result;
    }
    return rawPath;
  }

  replaceMenuExist(): void {
    this.menus.map(menu => {
      let submenuItem = this.submenus.filter(submenu => submenu.title === menu.title)[0];
      if (submenuItem) {
        menu.action = 'openPageBuilder';
        menu.pageBuilderId = submenuItem.pageBuilderId;
        menu.show = true;
        menu.iconUrl = this.generateMenuIconUrl(submenuItem.iconUrl);
        delete menu.icon;
        return menu;
      }
    });
  }

  openPageBuilder(pageBuilderId): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        await this.storage.ready();
        let hasil = await this.storage.get('SFGoAuth');
        if (hasil != null && hasil != undefined) {
          let SFGoAuth = JSON.parse(hasil);
          // let pageBuilderPages = await this.storage.get("pageBuilderPages");
          let version = await this.storage.get("pageBuilderVersion");
          let navParam = {
            pageId: pageBuilderId,
            pageTitle: 'Loading...',
            pageType: null,
            pageSchema: null,
            pageFile: null,
            pageParam: [],
            pageIsSub: false,
            userId: SFGoAuth.userId,
            static: null,
            cacheDuration: null,
            cacheStart: null,
            version: version,
          }
          this.storage.remove('pageBuilderActive');
          this.navCtrl.setRoot('InitPageBuilder', navParam);
        }
        resolve(true);
      } catch (error) {
        resolve(true);
      }
    })
  }

  massLeavePage() {
    this.navCtrl.push('MassLeavePage', { empid: this.empId, isProfile: this.isProfile });
  }

  runEvents(): Promise<any> {
    return new Promise((resolve) => {
      /**
       * RELOAD ATTENDANCE DATA
       */
      this.events.subscribe('attendance:success-record-attendance', async (val) => {
        if (val) {
          await this.checkAttendance();
          await this.funcAuth();
          this.getMenus();
          if (!_.isEmpty(this.navparams.data) && this.navparams.data.menuId) {
            await this.getSubmenus(this.navparams.data.menuId);
            if (this.submenus.length > 0) {
              this.replaceMenuExist();
            }
            this.flag.showMenu = true;
          } else {
            this.flag.showMenu = true;
          }
        }
      });

      /**
       * Load ketika aplikasi sleep
       */
      this.events.subscribe('attendance:sleep', (userEventData) => {
        this.subscriptions.push(
          this.sfattendanceApi.getCurrentTime().subscribe(
            result => {
              this.myDate = result.hasil.time;
            }
          )
        );
      });

      this.events.subscribe('login:isOnline', (ist) => {
        this.isOnline = ist.isOnline;
      });

      this.events.subscribe('user:timeattendancein', async (userEventData) => {
        this.disabledStart = true;
        this.newstarttime = moment(userEventData.newstarttime).format('HH:mm');
        await this.checkAttendance();
      });

      this.events.subscribe('user:timeattendanceout', async (userEventData) => {
        this.disabledStart = true;
        this.newendtime = moment(userEventData.newendtime).format('HH:mm');
        await this.checkAttendance();
      });

      this.events.subscribe('user:timeattendanceout2', async (userEventData) => {
        this.flag_yesterday_check = true;
        this.disabledStart = false;
        this.newstarttime = '';
        this.newendtime = '';
        this.attend_yesterday = [];
        this.subscriptions.push(
          this.sfattendanceApi.getYesterdayAttendanceData().subscribe(
            result => {
              this.attend_yesterday.push(result.hasil);
            }
          )
        );
        let msg = 'Success swipe out for yesterday'
        this.toastService.create(msg, 5000, 'bottom');
        // this.checkAttendanceSF6(); remark levi
        await this.checkAttendance();
      });

      resolve(true);
    })
  }

  geo() {
    window.plugins.geolocationPlugin.show('geo', 'location', function (success) {
      alert("data latitude :" + success.latitude);
    }, function (err) {
      alert("err :" + err);
    });
  }

  async checkAttendance() {
    this.flag_inputStatus = '';
    const isGopathNew = await this.attendanceBloc.nestApiProvider.isGoPathNewExist();
    if (isGopathNew) {
      await this.getNewTodayAttendance();
    } else {
      await this.getTodayAttendance();
    }
    await this.getTodayShift();
  }

  getTodayAttendance(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        this.isSkeleton = true;
        let result = await this.attendanceBloc.getTodayAttendance();
        if (result.success) {
          this.flag_inputStatus = result.result.flagInputStatus;
          this.feedBack = result.result.feedback;
          this.attendanceData.today.actualIn = result.result.actualIn;
          this.attendanceData.today.actualOut = result.result.actualOut;
          this.attendanceData.today.starttime = result.result.starttime;
          this.attendanceData.today.endtime = result.result.endtime;

          if (this.feedBack !== null && this.feedBack !== undefined) {
            this.storage.get('rating').then(data => {
              if (data == null || data == undefined) {
                this.showRating();
              }
            })
          }

          this.btnDisabled = false;
        } else {
          this.flag_inputStatus = 'in';
          this.btnDisabled = false;
        }
        this.isSkeleton = false;
        resolve(true);
      } catch (error) {
        this.flag_inputStatus = 'in'
        this.btnDisabled = false;
        this.isSkeleton = false;
        resolve(true);
      }
    })
  }

  async getNewTodayAttendance() {

    try {
      this.isSkeleton = true;
      const params = {
        date: new Date().toISOString(),
        empId: this.empId
      }

      this.attendanceData = await this.attendanceTempBloc.getNewTodayAttendance(params);
      this.flag_inputStatus = this.attendanceData;
      this.feedBack = this.attendanceData.today.feedback || null;

      if (this.feedBack !== null && this.feedBack !== undefined) {
        const ratting = await this.storage.get('rating');
        if (ratting == null || ratting == undefined) {
          this.showRating();
        }
      }

      this.btnDisabled = false;
      this.isSkeleton = false;
    } catch (error) {
      this.btnDisabled = false;
      this.isSkeleton = false;
    }
  }

  getTodayShift(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let result = await this.attendanceBloc.getTodayShift();
        if (result.success) {
          this.newshiftname = result.result.shiftdailyname;
          this.newshiftcode = result.result.shiftdailycode;
          this.newshiftstart = result.result.shiftstarttime;
          this.newshiftend = result.result.shiftendtime;
        } else {
          this.newshiftname = null;
          this.newshiftcode = null;
          this.newshiftstart = null;
          this.newshiftend = null;
        }
        resolve(true);
      } catch (error) {
        this.newshiftname = null;
        this.newshiftcode = null;
        this.newshiftstart = null;
        this.newshiftend = null;
        resolve(true)
      }
    })
  }

  getCurrentTime(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let time = await this.attendanceBloc.getCurrentTime();
        this.myDate = time;
        resolve(true);
      } catch (error) {
        resolve(true);
      }
    });
  }

  swapAlert() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('No Swipe Out'),
      subTitle: this.translate.instant('You haven\'t recorded the End Time for yesterday\'s shift. Do you want to do it now?'),
      buttons: [
        {
          text: 'Yes',
          handler: () => {
            this.flag_yesterday_check = false;
            this.flag_change_yesterday = true;
            this.newstarttime = moment(this.attend_yesterday[0].starttime).add(this.mindiff, 'minutes').format('HH:mm');
            this.disabledStart = true;
          }
        }
        , {
          text: 'No',
          handler: () => {
            this.flag_yesterday_check = true;
            this.attend_yesterday = [];
          }
        }]
    });
    alert.present();
  }

  checkforyesterday() {
    if (this.attend_yesterday[0] != undefined) {
      if (this.attend_yesterday.length > 0) {
        if ((this.attend_yesterday[0].starttime != null) && (this.attend_yesterday[0].endtime == null || this.attend_yesterday[0].endtime == '') && this.flag_change_yesterday == false && this.attend_today[0] == undefined) {
          this.swapAlert();
        } else {
          this.flag_can_start = true;
        }
      } else {
        this.flag_can_start = true;
      }
    } else {
      this.flag_can_start = true;
    }
  }

  onDev(): void {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('Warning!'),
      subTitle: this.translate.instant('Sorry, this page is under development'),
      buttons: ['OK']
    });
    alert.present();
  }

  leavePage() {
    this.navCtrl.push('leave2Page', { empid: this.empId, isProfile: this.isProfile });
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'leave');
  }

  attCorrectionPage() {
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'attendance correction');
    this.navCtrl.push('AttdCorrectionHistoryPage', { empid: this.empId, isProfile: this.isProfile });
  }

  attBaseDashboardPage() {
    this.navCtrl.push('AttBaseDashboardPage', { empId: this.empId, isProfile: this.isProfile });
  }

  btDeclarationPage() {
    this.navCtrl.push('BusinessTripDeclarationHistoryPage', { empid: this.empId, isProfile: this.isProfile });
  }

  attListPage() {
    if (this.empId == this.userEmpid) this.navCtrl.push('TimeAttendanceListNewPage', {
      empid: this.empId,
      isProfile: this.isProfile
    });
    if (this.empId != this.userEmpid) this.navCtrl.push('TimeAttendanceListDetailNewPage', {
      empid: this.empId,
      isProfile: this.isProfile,
      fromDetail: true
    });
  }

  attValidationPage() {
    this.navCtrl.push('AttendanceValidationPage', { empid: this.empId, isProfile: this.isProfile });
  }

  overtimePage() {
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'overtime');
    this.navCtrl.push('OvertimeHistoryPage2SF6', { empid: this.empId, isProfile: this.isProfile });
  }

  businessPage() {
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'business trip');
    this.navCtrl.push('BusinessTripPage', { empid: this.empId, isProfile: this.isProfile });
  }

  shiftPage() {
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'shift schedule');
    this.navCtrl.push('ShiftscheduleformPageSF6', {
      empid: this.empId,
      isProfile: this.isProfile,
      empname: this.empname,
      empno: this.empno
    });
  }

  async funcAuth(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        let listMenu = this.SFGoAuth.menu;
        if (listMenu == undefined) {
          // this.events.publish('user:logout', '');
        } else {
          this.showAE = listMenu["att-entry"];
          this.showAC = listMenu["att-correction"];
          this.showLeave = listMenu["att-leave"];
          this.showShift = listMenu["att-shift"];
          this.showOvt = listMenu["att-overtime"];
          this.showAL = listMenu["att-list"];
          this.showATTV = listMenu["att-validation"];
          this.showOffline = listMenu["att-offline"];
          this.showBarcode = listMenu["att-barcode"];
          this.showBST = listMenu["bst-request"];
          this.showMassLeave = listMenu["mass-leave"];
          this.showHelp = listMenu["att-help"];
          this.showABP = listMenu["att-base-photo"];
          resolve(true);
        }
      } catch (error) {
        this.showAE = false;
        this.showAC = false;
        this.showLeave = false;
        this.showShift = false;
        this.showOvt = false;
        this.showAL = false;
        this.showATTV = false;
        this.showOffline = false;
        this.showBarcode = false;
        this.showBST = false;
        this.showMassLeave = false;
        this.showHelp = false;
        this.showABP = false;
        resolve(true);
      }
    });
  }

  ionViewDidLeave(): any {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  async recordTimeBarcode() {
    if (this.platform.is('cordova')) {
      try {
        let data = await this.attendanceBloc.recordAttendanceBarcode(this.flag_inputStatus, this.isSF6, this.myDate);
        this.isRecordTime = false;
        if (data) {
          if (typeof data.mockDetect != 'undefined') {
            if (data.mockDetect) {
              this.navCtrl.push("ListBlockPackagePage", {
                packages: data.value
              });
            }
            return false;
          }
          this.events.publish('attendance:flag');
          this.events.publish('ATTENDANCE:RECORDATTENDANCEONLINE', data);
        }
      } catch (error) {
        this.isRecordTime = false;
      }
    }
  }

  async checkPolling() {
    const before = await this.checkBeforePolling();
    if (before) {
      this.recordTime();
    }
  }

  //BELOW ARE FUNCTION FOR SF6 ENTRY BY LEVI
  async recordTime() {
    this.isRecordTime = true;
    if (this.platform.is('cordova')) {
      try {
        let data = await this.attendanceBloc.recordAttendance();
        if (data) {
          if (typeof data.mockDetect != 'undefined') {
            this.progressRecord = this.translate.instant('Record Time');
            this.isRecordTime = false;
            if (data.mockDetect) {
              this.navCtrl.push("ListBlockPackagePage", {
                packages: data.value
              });
            }
            return false;
          }

          this.redirectAttPreviewPage(data);
        }
        else {
          this.progressRecord = this.translate.instant('Record Time');
          this.isRecordTime = false;
        }
      } catch (error) {
        this.progressRecord = this.translate.instant('Record Time');
        this.isRecordTime = false;
      }
    } else {
      if (this.attendanceBloc.params.setting.takePhoto) {
        this.navCtrl.push('TimeAttendanceWebcamSfgoPage').then(() => {
          this.navCtrl.getActive().onDidDismiss((data) => {
            if (data !== undefined) {
              this.recordAttendanceWeb(data);
            } else {
              this.isRecordTime = false;
              this.isDisabled = false;
              this.progressRecord = this.translate.instant('Record Time');
            }
          })
        })
      } else {
        this.recordAttendanceWeb();
      }
    }
  }

  recordAttendanceWeb(event?: any) {
    this.attendanceBloc.processWebImage(event).then(data => {
      if (data) {
        this.redirectAttPreviewPage(data);
      } else {
        this.isRecordTime = false;
        this.isDisabled = false;
        this.progressRecord = this.translate.instant('Record Time');
      }
    })
  }

  async redirectAttPreviewPage(data: AttendancePreviewData) {
    if (this.SFGoAuth.companySetting && this.SFGoAuth.companySetting.covid19Zone) {
      try {
        const attendanceZone = await this.attendanceBloc.covid19ZoneApi(data.geolocation);
        await this.navCtrl.setRoot("AttAlertRedZonePage", { attendanceData: data, attendanceZone: attendanceZone });
      } catch (error) {
        this.attendanceBloc.nestApiProvider.responseError(error);
      }
    } else {
      await this.navCtrl.push('TimeAttendancePreviewPage', { data: data });
    }

    this.isRecordTime = false;
    this.isDisabled = false;
    this.progressRecord = this.translate.instant('Record Time');
  }

  offlineAttendance() {
    this.navCtrl.push('OfflineModeListPage');
  }

  /**
   * SHOW TO STORAGE ATTENDANCE OFFLINE
   */
  runAttendanceOffline(item) {
    if (this.platform.is('cordova')) {
      let alert = this.alertCtrl.create({
        message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" /><h6 style="color:#808080;">` +
          this.translate.instant('Do you want to keep the record offline?') + `</h6>`,
        enableBackdropDismiss: false,
        buttons: [{
          text: this.translate.instant('Cancel'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('OK'),
          handler: () => {
            this.saveAttedanceOffline(item);
          }
        }]
      });
      alert.present();
    } else {

    }
  }

  /**
   * SAVE TO STORAGE ATTEDANCE OFFLINE
   */
  saveAttedanceOffline(item) {
    this.storage.get('SFGoAttendanceLog').then((attendance) => {
      if (attendance != null && attendance != undefined) {
        let data = JSON.parse(attendance);
        data.push(item);
        this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
      } else {
        let data = [];
        data.push(item);
        this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
      }
      const alert = this.alertCtrl.create({
        message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" /><h6 style="color:#808080;">` +
          this.translate.instant('Your attendance record is already saved') + `</h6>`,
        enableBackdropDismiss: false,
        buttons: [{
          text: 'Dismiss',
          handler: () => {

          }
        }]
      });
      alert.present();
    });
  }

  attListMap() {
    this.navCtrl.push('TimeAttendanceGmapsPage', { empId: this.empId });
  }

  funRunCheckWebabsent(): Promise<any> {
    return new Promise((resolve) => {
      this.subscriptions.push(
        this.settingServiceApi.checkWebabsent().subscribe((val) => {
          if (val) {
            resolve(true)
          } else {
            this.fileInput.nativeElement.value = "";
            let msg = "error_message:Can't be absent through the web";
            this.alertService.createWarnMola(msg).then((result) => {
              this.alertService.redirect(msg)
            })
          }
        }, error => {
          this.fileInput.nativeElement.value = "";
          let msg = 'error_message:Error when checking';
          this.alertService.createWarnMola(msg).then((result) => {
            this.alertService.redirect(error.message)
          })
        })
      );
    })
  }

  close() {
    if (this.viewCtrl) this.viewCtrl.dismiss();
  }

  showRating() {
    let modal = this.modalCtrl.create("RatingModalPage", {}, {
      cssClass: "grd-modal-rating",
      showBackdrop: true,
      enableBackdropDismiss: true
    });
    modal.present();
  }

  loadProfile(empId: String): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        const payload: RequestGetEmpDto = {
          empId: empId.toString(),
          userId: '',
          flag: 1
        }

        let result = await this.profileBloc.getEmp(payload);
        this.userId = result.userId;
        this.photoProfile = result.photo;
        this.name = result.fullName;
        this.position = result.posNameEn;

        resolve(true);
      } catch (error) {
        resolve(true);
      }
    })
  }

  async loadVersionApps() {
    await this.platform.ready()
    let device = this.platform.is('cordova');
    if (device) {
      let name = await this.appVersion.getVersionNumber()
      let code = await this.appVersion.getVersionCode()
      this.versionApps = `ver. ${name} - ${code}`;
    } else {
      this.versionApps = "ver. web";
    }
  }

  slideChanged() {
    let isEnd = this.slides.isEnd();
    let isBeginning = this.slides.isBeginning();
    if (isEnd) {
      this.toggleNext = false;
    } else if (!isEnd) {
      this.toggleNext = true;
    }
    if (isBeginning) {
      this.togglePrev = false;
    } else if (!isBeginning) {
      this.togglePrev = true;
    }
  }

  nextSlide() {
    this.slides.slideNext();
  }

  prevSlide() {
    this.slides.slidePrev();
  }

  showLog(params: { data: any, flag: 'today' | 'yesterday', empId?: any, attendDate?: any }) {
    params.empId = this.SFGoAuth.empId;
    params.attendDate = params.flag == 'today' ? moment().toISOString() : moment().startOf('day').add(moment().utcOffset(), 'minutes').subtract(1, 'day').toISOString();
    let modal = this.modalCtrl.create("TimeAttendanceLogPage", { paramPage: params });
    modal.present();
  }

  async checkBeforePolling(): Promise<boolean> {
    const arrayPoll = await this.pollingBloc.getPollingFromStorage();
    let next = true;
    if (arrayPoll) {
      const idx = arrayPoll.findIndex(i => i.prompt == 'before_attendance');
      if (idx != -1) {
        const poll = arrayPoll[idx];
        if (poll && poll.prompt == 'before_attendance') {
          next = false;
          if (poll.restrict) {
            this.navCtrl.setRoot("PollingWelcomePage", poll);
          } else {
            this.navCtrl.push("PollingWelcomePage", poll).then(() => {
              this.navCtrl.getActive().onDidDismiss(data => {
                this.setStorage(poll.surveyCode);
              });
            });
          }
        }
      }
    }
    return next;
  }

  async setStorage(surveyCode: any) {
    const arrayPoll = await this.pollingBloc.getPollingFromStorage();
    const idx = arrayPoll.findIndex(i => i.surveyCode == surveyCode);
    if (idx != -1) {
      arrayPoll.splice(idx, 1);
      await this.pollingBloc.setPollingToStorage(arrayPoll);
    }
  }

  async getBreakButton() {
    try {
      const showBreakBtn = await this.attendanceBloc.getBreakButton();
      this.attendanceBloc.setShowBreakTime(showBreakBtn);
      this.showBreakBtn = showBreakBtn;
    } catch (error) {
    }
  }

}




// WEBPACK FOOTER //
// ./src/pages/hr/time-attendance/time-attendance.ts